<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationSectionBleu'
});
</script>
<template>
  <ka-container
    code="p-formation-section-bleu"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Section -->
    <ka-container code="section">
      <ka-image
        code="image"
        :options="{
          animationIn: `fadeIn`,
          lazyOptions: {
            throttle: 200,
            once: true,
            intersection: { threshold: 0.1 }
          },
          imgFit: `cover`
        }"
        :xs="{ hidden: null }"
        :value="componentInstance.$picture.value" />
      <!-- Container -->
      <ka-container code="container">
        <ka-text code="titre">
          <h2 v-html="componentInstance.$title.value" />
        </ka-text>
        <ka-text code="text">
          <span v-html="componentInstance.$paragraph.value" />
        </ka-text>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationSectionBleuComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c26')
const component = pFormationSectionBleuComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  paragraph?: Nullable<string>
  title?: Nullable<string>
  picture?: Nullable<string | File>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  paragraph: '',
  title: '',
  picture: undefined,
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:paragraph',
  'update:title',
  'update:picture'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    paragraph: true,
    title: true,
    picture: true
  }
})
</script>
